
    var riot = require('riot')
    //src: starling/src/tags/menu/region-shape-menu.html
riot.tag2('region-shape-menu',
  '<ul if="{isOpen}" class="floating-menu_list floating-menu_list--grid"> <li class="floating-menu_heading">Shape</li> <li each="{shape in shapes}" class="floating-menu_item {floating-menu_item--active: isShapeSelected(shape)}" onclick="{selectShape}"> <svg class="floating-menu_icon floating-menu_icon--large"> <use xlink:href="#region-shape-{shape}-icon"></use> </svg> </li> </ul>',
  '',
  'class="floating-menu {floating-menu--hidden: !isOpen}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _menuUi = require('lib/menu-ui');

var _opts = opts,
    canvas = _opts.canvas;

canvas.regionShapeMenu = this;

this.isOpen = false;
this.referenceTag = null;
this.shapes = _constants.REGION_SHAPES;
this.selectedShape = null;

this.on('mount', function () {
  return _this.updateSelectedShape();
});
this.on('update', function () {
  return _this.updateSelectedShape();
});

this.updateSelectedShape = function () {
  var referenceTag = _this.referenceTag;

  _this.selectedShape = referenceTag && _menuUi.mui.getSelectedRegionsShape.apply(referenceTag);
};

this.selectShape = function (_ref) {
  var shape = _ref.item.shape;
  return _menuUi.mui.setRegionShape.call(_this.referenceTag, shape);
};

this.isShapeSelected = function (shape) {
  return shape === _this.selectedShape;
};

this.positionSelf = function (_ref2) {
  var position = _ref2.position;

  var _referenceTag$root$ge = _this.referenceTag.root.getBoundingClientRect(),
      left = _referenceTag$root$ge.left,
      right = _referenceTag$root$ge.right,
      top = _referenceTag$root$ge.top,
      bottom = _referenceTag$root$ge.bottom;

  _this.root.style = '\n        --floating-menu-grid-columns: 3;\n        --floating-menu-z-index: 100000;\n        top: ' + (position === 'below' ? bottom + 4 : top) + 'px;\n        left: ' + (position === 'below' ? left : right) + 'px;\n      ';
};

this.summon = function (_ref3) {
  var referenceTag = _ref3.referenceTag,
      position = _ref3.position;

  _this.update({ isOpen: true, referenceTag: referenceTag });
  _this.positionSelf({ position: position });
};

this.close = function () {
  return _this.update({ isOpen: false, referenceTag: null });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('region-shape-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/region-shape-menu.html
// module id = 682
// module chunks = 0